import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';

const PastRecords = () => {
  const [images, setImages] = useState([]);

  useEffect(() => {
    try {
      const imageContext = require.context('../assets/images/log', false, /\.(webp)$/);
      const imagePaths = imageContext.keys()
        .filter(key => !key.includes('placeholder.jpg'))
        .map(key => imageContext(key));
      setImages(imagePaths);
    } catch (error) {
      console.error('圖片載入錯誤:', error);
    }
  }, []);

  const duplicatedImages = [...images, ...images, ...images];

  return (
    <section
      id="past"
      className="bg-gradient-to-br from-[#e6f0fa]/90 to-[#ffffff]/90 backdrop-blur-sm flex flex-col items-center justify-center overflow-hidden pt-16 pb-16"
    >
      <motion.h2
        initial={{ opacity: 0, y: 50 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6 }}
        className="max-w-7xl mx-auto px-2 sm:px-4"
      >
        <div className="text-center mb-12">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold bg-gradient-to-r from-[#60a5fa] to-[#93c5fd] bg-clip-text text-transparent">
            營隊回顧
          </h2>
          <p className="mt-4 text-base sm:text-lg md:text-xl text-[#475569] font-light">
            回顧過去營隊的精彩瞬間，感受學習與成長的點滴
          </p>
        </div>
      </motion.h2>

      <div className="space-y-8 w-full">
        <motion.div
          initial={{ opacity: 0, x: -50 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="relative"
        >
          <div className="film-strip-container">
            <div className="film-strip animate-scroll-right">
              {duplicatedImages.map((img, idx) => (
                <div key={idx} className="film-frame">
                  <div className="film-holes">
                    <div className="hole"></div>
                    <div className="hole"></div>
                    <div className="hole"></div>
                    <div className="hole"></div>
                  </div>
                  <div className="film-image">
                    <img
                      src={img}
                      alt={`營隊回顧 ${idx + 1}`}
                      className="w-full h-full object-cover"
                      loading="lazy"
                    />
                  </div>
                  <div className="film-holes">
                    <div className="hole"></div>
                    <div className="hole"></div>
                    <div className="hole"></div>
                    <div className="hole"></div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, x: -50 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.2 }}
          className="relative"
        >
          <div className="film-strip-container">
            <div className="film-strip animate-scroll-left">
              {duplicatedImages.map((img, idx) => (
                <div key={idx} className="film-frame">
                  <div className="film-holes">
                    <div className="hole"></div>
                    <div className="hole"></div>
                    <div className="hole"></div>
                    <div className="hole"></div>
                  </div>
                  <div className="film-image">
                    <img
                      src={img}
                      alt={`營隊回顧 ${idx + 1}`}
                      className="w-full h-full object-cover"
                      loading="lazy"
                    />
                  </div>
                  <div className="film-holes">
                    <div className="hole"></div>
                    <div className="hole"></div>
                    <div className="hole"></div>
                    <div className="hole"></div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </motion.div>
      </div>

      <style>{`
        .film-strip-container {
          width: 100vw;
          overflow: hidden;
          background: rgba(96,165,250,0.15);
          padding: 10px 0;
          border-radius: 8px;
          border: 1px solid rgba(224,231,255,0.5);
          position: relative;
          left: 50%;
          right: 50%;
          margin-left: -50vw;
          margin-right: -50vw;
        }

        .film-strip {
          display: flex;
          width: fit-content;
        }

        .film-frame {
          flex-shrink: 0;
          width: 280px;
          height: 200px;
          background: rgba(96,165,250,0.1);
          border: 2px solid rgba(224,231,255,0.5);
          border-radius: 6px;
          margin: 0 8px;
          display: flex;
          flex-direction: column;
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
          transition: transform 0.3s ease, box-shadow 0.3s ease;
        }

        .film-frame:hover {
          transform: scale(1.05);
          box-shadow: 0 8px 20px rgba(96,165,250,0.3);
        }

        .film-holes {
          display: flex;
          justify-content: space-around;
          padding: 6px 10px;
          background: rgba(96,165,250,0.1);
        }

        .hole {
          width: 12px;
          height: 12px;
          background: rgba(224,231,255,0.2);
          border-radius: 2px;
          border: 1px solid rgba(147,197,253,0.5);
        }

        .film-image {
          flex: 1;
          background: rgba(96,165,250,0.1);
          overflow: hidden;
        }

        .film-image img {
          transition: transform 0.3s ease;
        }

        .film-frame:hover .film-image img {
          transform: scale(1.1);
        }

        @keyframes scrollRight {
          0% {
            transform: translateX(0);
          }
          100% {
            transform: translateX(-33.333%);
          }
        }

        @keyframes scrollLeft {
          0% {
            transform: translateX(-33.333%);
          }
          100% {
            transform: translateX(0);
          }
        }

        .animate-scroll-right {
          animation: scrollRight 45s linear infinite;
        }

        .animate-scroll-left {
          animation: scrollLeft 45s linear infinite;
        }

        .animate-scroll-right:hover,
        .animate-scroll-left:hover {
          animation-play-state: paused;
        }

        /* 響應式設計 */
        @media (max-width: 640px) {
          .film-frame {
            width: 200px;
            height: 150px;
          }
          
          .hole {
            width: 8px;
            height: 8px;
          }
          
          .film-holes {
            padding: 4px 8px;
          }
        }
      `}</style>
    </section>
  );
};

export default PastRecords;